import { api, apiFile } from "api/api";
import { AxiosError } from "axios";
import HelpdeskTramite from "model/helpdesk/HelpdeskTramite";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class HelpdeskBatePapoService {

    pesquisar( id: number, page: Pageable) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/helpdeskBatePapo/pesquisar/${id}`;
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => {
                    reject(err.response);
                    console.error('Error status:', err.response?.status);
                    console.error('Error details:', err.response?.data);
                })
        });
    }

    gerar(data: FormData) {
        return new Promise<HelpdeskTramite>((resolve, reject): void => {
            apiFile
                .post(`/helpdeskBatePapo/gerar`, data)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
}

export default HelpdeskBatePapoService;